import React, { Component } from "react";
import { isIphone, isMobile } from "../../utils/deviceInfo";
import FooterBar from "../../components/FooterBar/FooterBar";
import axios from '../../axios';
import autosize from "autosize";
import moment from "moment";
import DaniFloatButton from "./DaniFloatButton";
import DaniContainer from "./DaniContainer";
import BenchMarkDetailsModal from "./BenchMarkDetailsModal";
import DaniIcon from "./../../assets/homa1.png";
import DaniHeader from "./DaniHeader";
import DaniContent from "./DaniContent";
import DaniTextStep from "./DaniTextStep";
import sortBy from "lodash/sortBy";
import reverse from "lodash/reverse";
import DaniOptionsStep from "./DaniOptionsStep";
import { IoIosArrowBack } from "react-icons/io";
import { FaRegComments } from "react-icons/fa";
import { connect } from "react-redux";
import WaveHand from "./../../assets/wave_hand_emoji.svg";
import { socketConnection } from "../../socketClient";
import { TiMessages } from "react-icons/ti";
import * as actionCreators from "../../modules/actions/index";
import {
  welcomeStep,
  TRIGGER_TYPE_FUNCTION,
  SELECT_KPI_MESSAGE, 
  USEFUL_TOOLS_TEXT,
  UPLOAD_PDF_CONFIRM,
} from "../../utils/daniUtilsTranslate";
import { isProfane } from "../../utils/validations";
import {
  chatQuerySearchTypes,
  readWordfile,
  staticTitles,
  xtract,
  get_utc_offset
} from "../../utils/constants";
import {
  get_translation
} from "../../utils/translation";
import { marked } from "marked";
import parse from "html-react-parser";
import { Button } from "reactstrap";
import map from "lodash/map";
import find from "lodash/find";
// import Filter from 'bad-words';
import DaniSearchResultStep from "./DaniSearchResultStep";
import {
  BiLinkExternal,
  BiChevronRight,
  BiEdit,
  BiTrash,
} from "react-icons/bi";
import GoBackComponent from "./GoBackComponent";
import { generateRandomString } from "../../utils/stringUtils";
import TurndownService from "turndown";
import { gfm } from "turndown-plugin-gfm";
import {
  BsDownload,
  BsEraser,
  BsGear,
  BsXCircle,
  BsQuestionCircle,
  BsChatDotsFill,
  BsChatDots,
  BsFile,
  BsUpload,
} from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import { toastContainer } from "../../utils/toast";
import mammoth from "mammoth";
import { Row, Col } from "reactstrap";

class FreeDani extends Component {
  constructor(props) {
    super(props);
    this.content = null;
    let { renderInPage, dani } = props;
    renderInPage=true;
    const handleActionTakeRender = () => {
      if (!renderInPage && dani.renderedSteps.length === 0) {
        return true;
      } else {
        return false;
      }
    };
    console.log('FreeDani')
    this.state = {
      selectedKpiName: "",
      showChatSettings: false,
      searchType: chatQuerySearchTypes.AI_SINGLE_QUESTION,
      preQuestionData: {
        questionOn: "",
        questionOnValue: "",
        industryValue: "",
      },
      inputLength: 0,
      actionTaken: renderInPage ? false : handleActionTakeRender(),
      feedbackQueAnswers: [],
      exporting: false,
      settingTitle: "",
      isChatPage: false,
      currentChatOrder: null,
      selectedFile: null,
      outsideUS:false,
    };
  }

  extractTextFromWordDocument = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onloadend = () => {
        let tagData = Buffer(reader.result).toString();

        tagData = tagData
          .replace(/<[^>]+>/g, "")
          .replace("Export HTML To Doc", "");

        console.log(tagData);
        resolve(tagData);
      };

      reader.onerror = (error) => {
        reject(error);
      };
    });
  };

  readWordDocument = async (file) => {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = function(e) {
        const arrayBuffer = e.target.result;

        mammoth
          .extractRawText({ arrayBuffer: arrayBuffer })
          .then((result) => {
            const content = result.value; // Extracted content
            resolve(content.replace(/\n+/g, "\n"));
          })
          .catch((error) => {
            reject(error);
          });
      };

      reader.readAsBinaryString(file);
    });
  };

  onFileChange = async (event) => {
    const analyzeStep = {
      id: "analyze-load",
      message: "Thank you, reading in  your document, one moment please",
    };

    this.props.triggerStep(analyzeStep);

    this.setState({ selectedFile: event.target.files[0] }, async () => {
      const file = this.state.selectedFile;

      if (file != undefined && file.type == "application/pdf") {
        let fr = new FileReader(); // Create a new FileReader object
        fr.readAsDataURL(file); // Read the file as data URL
        fr.onload = async () => {
          console.log("fr ---->", fr);
          let res = fr.result; // Get the result of file reading
          console.log("res ---- ", res);
          const newTxt = await xtract(res, false);
          console.log("newTxt --- ", newTxt);
          this.props.setDaniExtractedText(newTxt);
          // ? `Text extracted successfully. What would you like me to do with it? Please select an option below.
          // <br/><br/> Extracted Text : ${newTxt.substring(0, 250)}...
          const step = {
            id: "showExtracted",
            message: newTxt
              ? `Great. Here's a short snippet of your file below.
                <br/><br/>"${newTxt.substring(0, 250)}..."
              `
              : "Hm, I couldn't read this file. Can you please try with other file",
          };
          if (newTxt) {
            this.props.triggerStep(step);
            this.props.triggerStep({
              message: "Is this the text you would like me to review?",
            });
            this.props.triggerStep(UPLOAD_PDF_CONFIRM);
            //this.props.triggerStep(UPLOAD_PDF_OPTIONS_AFTER_RESPONSE);
          } else {
            this.props.triggerStep({ id: "15", showInput: true, trigger: "" });
          }
        };
      } else if (
        (file != undefined &&
          file.type ==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document") ||
        file.type === "application/msword" ||
        file.name.indexOf(".doc") > -1 ||
        file.name.indexOf(".docx") > -1
      ) {
        try {
          let newTxt = "";
          if (file.name.indexOf(".docx") > -1) {
            newTxt = await this.readWordDocument(file);
          } else {
            newTxt = await this.extractTextFromWordDocument(file);
          }

          this.props.setDaniExtractedText(newTxt);

          const step = {
            id: "showExtracted",
            message: newTxt
              ? `Great. Here's a short snippet of your file below.
                <br/><br/>"${newTxt.substring(0, 250)}..."
              `
              : "Hm, I couldn't read this file. Can you please try with other file",
          };
          if (newTxt) {
            this.props.triggerStep(step);
            this.props.triggerStep({
              message: "Is this the text you would like me to review?",
            });
            this.props.triggerStep(UPLOAD_PDF_CONFIRM);
            //this.props.triggerStep(UPLOAD_PDF_OPTIONS_AFTER_RESPONSE);
          } else {
            this.props.triggerStep({ id: "15", showInput: true, trigger: "" });
          }
        } catch (error) {
          this.props.triggerStep({ id: "15", showInput: true });
          toastContainer("Error while reading word doc", "error");
          console.error(error);
        }
      } else {
        this.props.triggerStep({ id: "15", showInput: true });
        toastContainer("Please upload PDF / Word", "error");
      }
    });
  };

  setFeedbackQue = (data) => {
    this.setState({ feedbackQueAnswers: [...data] });
  };
  componentDidUpdate() {
    autosize(this.questionInput);
  }

  componentDidMount() {
    this.content.addEventListener("DOMNodeInserted", this.onNodeInserted);
    window.addEventListener("resize", this.onResize);
    autosize(this.questionInput);

    let lang_set = get_utc_offset()

    if(lang_set){
      this.setState({outsideUS: true})
    }

    this.props.history.listen((location, action) => {
      const { opened } = this.props.dani;
      if (!location.pathname.includes("toolkit") && opened) {
        this.props.closeDani();
      }
    });

    console.log('free dani -- didmount')
    this.storeAndStartNewChat()
    let { renderInPage, dani } = this.props;
    // renderInPage=true
    if (renderInPage && dani.renderedSteps.length === 0) {
      //this.props.openDani();
      this.props.addDaniHistoryChats();

      setTimeout(() => {
        this.triggerFirstStep();
      }, 500);
    }

    if (!renderInPage) {
      if (!dani.renderedSteps.length) {
        this.setState({ actionTaken: true });
      } else {
        this.setState({ actionTaken: false });
      }
    }
  }

  componentWillUnmount() {
    this.content.removeEventListener("DOMNodeInserted", this.onNodeInserted);
    window.removeEventListener("resize", this.onResize);
  }

  onResize() {
    if (this.content) {
      this.content.scrollTop = this.content.scrollHeight;
    }
  }

  handleFloatButtonClick = () => {
    const { opened, minimized, renderedSteps } = this.props.dani;
    if (opened) {
      if (minimized) {
        this.props.maximizeDani();
      } else {
        this.props.closeDani();
      }
    } else {
      this.props.openDani();

      if (!renderedSteps.length) {
        this.setState({ actionTaken: true });

        this.props.addDaniHistoryChats();

        setTimeout(() => {
          this.triggerFirstStep();
        }, 500);
      } else {
        this.setState({ actionTaken: false });
      }
    }
  };

  handleQuestionSubmit = (extractTextOperation) => {
    const { renderInPage } = this.props;

    this.setState({ actionTaken: true });

    let value = this.questionInput.value;
    if (value.length === 0 || value.trim().length === 0) {
      return;
    }

    const handleProfane = () => {
      const step = Object.assign(
        {},
        { id: "", message: `${value}`, user: true, trigger: "" }
      );
      this.props.triggerStep(step);

      const profaneStep = Object.assign(
        {},
        {
          id: "",
          message: `Sorry. I’m not trained to understand this. 
      Please modify it or ask me a different question.`,
          trigger: "13",
        }
      );
      this.props.triggerStep(profaneStep);
    };

    if (
      [
        chatQuerySearchTypes.SCRAPE,
        chatQuerySearchTypes.AI_SINGLE_QUESTION,
      ].includes(this.state.searchType)
    ) {
      if (isProfane(value)) {
        handleProfane();
      } else {
        const step = Object.assign(
          {},
          {
            id: "input-ques-identifier",
            message: `${value}`,
            user: true,
            trigger: "FETCH_SEARCH_RESULTS",
            triggerType: TRIGGER_TYPE_FUNCTION,
            isPdfExtract:extractTextOperation,
            extractedMessage:this.props.dani.extractedText
          }
        );
        this.props.triggerStep(step);
      }
    } else {
      if (isProfane(value)) {
        handleProfane();
      } else {
        const { preQuestionData } = this.state;

        if (!preQuestionData.questionOn) {
          const step = Object.assign(
            {},
            {
              id: "",
              message: `${value}`,
              user: true,
              trigger: "GET_QUESTION_ON_VALUE",
            }
          );
          this.props.triggerStep(step);
          this.setState({
            preQuestionData: {
              questionOn: value,
              questionOnValue: "",
              industryValue: "",
            },
          });
        } else {
          if (!preQuestionData.questionOnValue) {
            const step = Object.assign(
              {},
              {
                id: "",
                message: `${value}`,
                user: true,
                trigger: "GET_INDUSTRY_VALUE",
              }
            );
            this.props.triggerStep(step);
            this.setState({
              preQuestionData: {
                ...this.state.preQuestionData,
                questionOnValue: value,
                industryValue: "",
              },
            });
          } else {
            if (!preQuestionData.industryValue) {
              const step = Object.assign(
                {},
                {
                  id: "",
                  message: `${value}`,
                  user: true,
                  trigger: "FETCH_SEARCH_RESULTS",
                }
              );
              this.props.triggerStep(step);
              this.setState({
                preQuestionData: {
                  ...this.state.preQuestionData,

                  industryValue: value,
                },
              });
            }
          }
        }
      }
    }

    this.questionInput.value = "";
  };

  createPDFExtractMessage = (step) => {
    if (step.id == "fo-1") {
      return `Can you improve below text more inclusively with gaps?
      ${step.extractedMessage}
      `;
    }
    if (step.id == "fo-2") {
      return `Can you do sentiment analysis of below text (Both Positive / Negative) and provide me  ? 
      ${step.extractedMessage}
      `;
    }
    if (step.id == "fo-3") {
      return `Can you tell key topics or outline of below text? 
      ${step.extractedMessage}
      `;
    }
    if (step.id == "input-ques-identifier") {
      return `${step.message} from below text -:
      ${step.extractedMessage}
      `;
    }
  };

  handleTriggerNextStep = (step) => {
    console.log('step --- ', step)
    const { renderedSteps } = this.props.dani;
    const { kpiMasterList } = this.props.kpiMaster;
    const { preQuestionData, actionTaken } = this.state;
    //nothing to trigger next step. return;
    if (step.trigger === "" || !actionTaken) {
      return;
    }

    //selection of option was the current step. dispatch option selected
    if (step.isOption) {
      this.props.optionSelected(step);
    } else {
      if (step.trigger === "FETCH_RECOMMENDED_TOOLS") {
        // Binding Socket Event - Dani_Tool_Subcategory_Click.
        // socketConnection.track("Dani_Tool_Subcategory_Click", {
        //   kpiName : '',
        //   toolkitCategoryName : '',
        //   toolSubcategoryName : ''
        // });
        const { selectedChart } = this.props.dani;
        // console.log("selectedChart", selectedChart);
        if (selectedChart.kpiData.length === 1) {
          // console.log("userClickedAPI", {selectedChart});
          this.props.fetchRecommendedTools(selectedChart.kpiData[0].kpiId.code);
        } else {
          const nextStep = SELECT_KPI_MESSAGE;
          this.props.triggerStep(nextStep);
        }
      } else if (step.trigger === "SHOW_SOLUTIONS") {
        const { selectedChart } = this.props.dani;
        if (selectedChart.kpiData.length === 1) {
          this.props.triggerStep(USEFUL_TOOLS_TEXT);
        } else {
          const nextStep = SELECT_KPI_MESSAGE;
          this.props.triggerStep(nextStep);
        }
      } else if (step.trigger === "RECOMMENDED_TOOLKIT_SELECTED") {
        // console.log("inDaniRedirect");
        // console.log('allData', {step})
        // console.log('allData', this.props.dani.selectedChart);
        this.props.history.push({
          pathname: step.url,
          state: { selectedKPIName: this.state.selectedKpiName },
        });
        const nextStep = Object.assign(
          {},
          {
            id: "",
            message: `If there is a helpful ${staticTitles.toolkit_sm} available in the category you picked, you can see the details by clicking it.`,
            trigger: "",
            end: true,
            subcategory: step.subcategory,
          }
        );
        this.props.triggerStep(nextStep);
        // this.props.toolkitSelected(nextStep);
      } else if (step.trigger === "SELECT_KPI_FOR_CHART") {
        this.props.selectKpiForChart(this.props.dani.selectedChart);
      } else if (step.trigger === "KPI_FOR_CHART_SELECTED") {
        const kpiName = renderedSteps[renderedSteps.length - 3].message;
        // Storing Click KPI Name to Store
        this.setState({ selectedKpiName: kpiName });
        const kpi = find(kpiMasterList, { name: kpiName });
        this.props.fetchRecommendedTools(kpi.code);
      } else if (step.trigger === "FETCH_SEARCH_RESULTS") {
        if (
          this.state.searchType === chatQuerySearchTypes.AI_TWO_PARTS_QUESTION
        ) {
          const queryData = { ...preQuestionData };
          this.props.fetchSearchResults(
            `What is percantage of ${queryData.questionOnValue} in ${queryData.industryValue}?`,
            this.state.searchType,
            this.props.dani.assistantSessionMessages
          );
          this.setState({
            preQuestionData: {
              questionOn: "",
              questionOnValue: "",
              industryValue: "",
            },
          });
          //const loadingStep = Object.assign(
          //  {},
          //  {
          //    id: "load-1",
          //    message: `Thank you for your responses. Let me see what I can find…`,
          //    trigger: "WAIT_CHAT_RES",
          //    end: true,
          //  }
          //);
          //this.props.triggerStep(loadingStep);
        } else {
          if (
            this.state.searchType === chatQuerySearchTypes.AI_SINGLE_QUESTION
          ) {
          }
          let message = step.message;

          let isShowMore = false;

          if (step.showMore) {
            isShowMore = true;
            message = step.framedQuestion;
          }

          if (step.isPdfExtract) {
            message = this.createPDFExtractMessage(step);
          }

          if(step.messageOption && step.messageOption.length>0){
            message = step.messageOption
          }
          console.log('step befoer Search --- ', step)
          const downloadable = step.isPdfExtract;


          let default_language = this.state.outsideUS?'fa':''

          this.props.fetchSearchResults(
            message,
            this.state.searchType,
            this.props.dani.assistantSessionMessages,
            this.props.dani.apiValue,
            isShowMore,
            downloadable,
            step,
            this.props.dani.currentChatId,
            true, // isOpenAPI: true,
            default_language
          );
        }
      } else if (step.trigger === "DRILLDOWN_CHART") {
        this.props.drillDownChart();
      } else if (step.trigger === "FETCH_MORE_RESULTS") {
        const { searchResults, searchResultPage } = this.props.dani;
        if (searchResults.length < searchResultPage + 1) {
          const nextStep = Object.assign(
            {},
            {
              id: "",
              message: `Please try rephrasing your question to see more results.`,
              trigger: "",
              end: true,
            }
          );
          this.props.triggerStep(nextStep);
          this.props.triggerStep({ id: "15", showInput: true, trigger: "" });
        } else {
          this.props.fetchMoreSearchResults(
            searchResults,
            searchResultPage + 1,
            this.state.searchType,
            this.props.dani.assistantSessionMessages,
            this.props.dani.apiValue
          );
        }
      } else if (step.trigger === "CLOSE_DANI") {
        this.props.closeDani();
      } else if (step.trigger === "WAIT_CHAT_RES") {
      } else if (step.trigger === "GET_QUESTION_ON_VALUE") {
        const step = Object.assign(
          {},
          {
            id: "",
            message: `Please select ${preQuestionData.questionOn}`,
            trigger: "15",
            end: true,
          }
        );
        this.props.triggerStep(step);
      } else if (step.trigger === "GET_INDUSTRY_VALUE") {
        const step = Object.assign(
          {},
          {
            id: "",
            message: `Please select industry`,
            trigger: "15",
            end: true,
          }
        );
        this.props.triggerStep(step);
      } else if (step.trigger === "SEND_ANSWER_FEEDBACK") {
        const step1 = Object.assign(
          {},
          {
            id: "",
            message: step.message,
            trigger: "15",
            user: step.user,
            end: true,
          }
        );

        this.props.triggerStep(step1);
        this.props.triggerStep({ id: "15", showInput: true, trigger: "" });
      } else {
        this.props.triggerNextStep(step);
      }
    }
  };

  openChatsPage = () => {
    this.setState({ isChatPage: true, showChatSettings: true });
  };

  onNodeInserted(event) {
    event.currentTarget.scrollTop = event.currentTarget.scrollHeight;
  }

  handleKeyPress = (e,flag) => {
    if (e.key === "Enter" && !e.shiftKey) {
      this.handleQuestionSubmit(flag);
    }

    this.setState({ inputLength: this.questionInput.value.length });
    // if(this.questionInput && this.questionInput.value){
    //   console.log('return --- ', this.questionInput.value.length)
    //   console.log('total --- ', this.questionInput.value.length+1)
    //   this.setState({inputLength: this.questionInput.value.length + 1})
    // } else {
    //   this.setState({inputLength: 0})
    // }
  };


  handlePersonaSettingOverlay = (settingTitle) => {
    this.setState({ showChatSettings: true, settingTitle: settingTitle });
  };

  setSearchType = (type) => {
    const { renderInPage } = this.props;

    this.setState({ actionTaken: 1 });

    this.setState({ searchType: type });
  };

  triggerFirstStep = () => {
    this.props.triggerStep({ ...welcomeStep[0], timeStamp: new Date() });
  };

  handleCorrectAnswer = () => {
    const step = Object.assign(
      {},
      {
        id: "",
        message: `Great to hear. thank you for your question`,
        trigger: "15",
        end: true,
      }
    );
    this.props.triggerStep(step);
    this.props.triggerNextStep(step);
  };

  actionTakenOn = () => {
    this.setState({ actionTaken: true });
  };

  getQuestionBasedOnType = (type) => {
    switch (type) {
      case "show_more":
        return "provide more detailed information with as many examples , url links ,refrences and pieces of data as possible";

      case "clarify":
        return "clarify this?";

      case "exemplify":
        return "Provide me more real world examples of this ";

      case "expand":
        return "Expand on this in detail by giving real world examples";

      case "explain":
        return "Explain this step by step, in simple language with a list of main points?";

      case "rewrite":
        return "Rewrite this adding more context?";

      case "shorten":
        return "Shorten this?";

      case "show_links":
        return "Provide a list of url links for the above answer";

      case "summarize":
        return "Summarize the previous response as a list of summary points, and in a separate paragraph, at the bottom, add a text mind map with branches and sub-branches";

      default:
        return "";
    }
  };

  handleShowMore = (object) => {
    this.setState({ actionTaken: true });
    const step = Object.assign(
      {},
      {
        id: "",
        message: `${object.label}`,
        user: true,
        trigger: "FETCH_SEARCH_RESULTS",
        triggerType: TRIGGER_TYPE_FUNCTION,
        showMore: true,
        framedQuestion: this.getQuestionBasedOnType(object.value),
      }
    );
    this.props.triggerStep(step);
  };

  renderSteps = (step, index) => {
    const { opened, selectedChart, renderedSteps } = this.props.dani;
    let { renderInPage } = this.props;
    renderInPage=true
    let profilePic = this.props.user.profile.profilePic;
    //if Dani is not opened, do not trigger any steps;
    if (!opened) {
      if (!renderInPage) {
        return;
      }
    }

    //need not render this step because user is expected to type
    if (step.showInput) {
      return;
    }

    if (step.searchResults) {
      const { searchedTerm } = this.props.dani;
      return (
        <DaniSearchResultStep
          isFreeDani = {true}
          setDaniResponseLoading={this.props.setDaniResponseLoading}
          actionTakenOn={this.actionTakenOn}
          current={this.props.dani}
          step={step}
          previousStep={renderedSteps[index > 0 ? index - 1 : index]}
          user={this.props.user.profile}
          index={index}
          key={index}
          triggerNextStep={this.handleTriggerNextStep}
          userPic={profilePic}
          searchedTerm={searchedTerm}
          updateStep={this.props.updateStep}
          handleCorrectAnswer={this.handleCorrectAnswer}
          handleShowMore={this.handleShowMore}
          latestStepId={this.props.dani.latestStepId}
          setFeedbackQue={this.setFeedbackQue}
          feedbackQueAnswers={this.state.feedbackQueAnswers}
          showSettings={this.handlePersonaSettingOverlay}
          exportPDF={this.exportConvoPDF}
          exportWord={this.export2Word}
          fileMultiPartsData={this.props.dani.fileMultiplePartsResponse}
          resetDaniFileMultiPartData={this.props.resetDaniFileMultiPartData}
        />
      );
    }
    if (step.options) {
      return (
        <DaniOptionsStep
          key={index}
          step={step}
          triggerNextStep={this.handleTriggerNextStep}
          currentRoute={this.props.location.pathname}
          userPic={profilePic}
          chart={selectedChart}
          setSearchType={this.setSearchType}
          extractedText={this.props.dani.extractedText}
          actionTakenOn={this.actionTakenOn}
        />
      );
    } else {
      return (
        <DaniTextStep
          key={index}
          step={step}
          freeDaniImg={DaniIcon}
          triggerNextStep={this.handleTriggerNextStep}
          isLast={step.end}
          loggedInUser={this.props.user.profile}
          userPic={profilePic}
        />
      );
    }
  };

  parseUrls = (text) => {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '" target="_blank">' + url + "</a>";
    });
  };

  exportConvoPDF = async (id) => {
    const { renderInPage } = this.props;
    // console.log(this.state.exporting,document.querySelector("#jspdf_export_conversation"))
    // const pdf = new jsPDF("portrait", "pt", "a4");
    const data = await document.querySelector(
      id || "#jspdf_export_conversation"
    );

    console.log(window.html2pdf)

    const pdf = window.html2pdf().from(data)
  

    // pdf.setFont("Arial", "normal");
    // pdf.setLanguage("mr")

    // pdf.html(data,{
    //   fontFaces:[
    //     {family:"Arial, Roboto, sans-serif"
    //   }]
    // })
    
    
    pdf.then(async() => {
      this.setState({ exporting: false });

      if (renderInPage) {
        pdf.save(
          `${moment(new Date()).format(
            "dddd, MMMM Do YYYY, h:mm:ss a"
          )} - dani.pdf`
        );
      } else {
        var string = await pdf.output("datauristring")
        console.log(string)
        var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
        var x = window.open();
        x.document.open();
        x.document.write(embed);

        var a = document.createElement("A");
        var filePath = await pdf.output("datauristring");
        a.href = filePath;
        a.download = `${moment(new Date()).format(
          "dddd, MMMM Do YYYY, h:mm:ss a"
        )} - dani.pdf`;
        document.body.appendChild(a);
        setTimeout(() => {
          a.click();
          document.body.removeChild(a);
          x.close();
        }, 700);
      }
    });
  };

  replaceTag = (message) => {
    if (!message) {
      return;
    }

    return message
      .replaceAll("```", "")
      .replaceAll("``", "")
      .replaceAll("`", "");
  };

  sanitizeDescription = (text) => {
    let txt = this.parseUrls(text);
    txt = this.replaceTag(txt);
    String.prototype.replaceAll = function(strReplace, strWith) {
      var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var reg = new RegExp(esc, "ig");
      return this.replace(reg, strWith);
    };
    return txt
      .replace("As an AI language model", "As a virtual assistant")
      .replace("AI language model", "Virtual assistant")
      .replace("artificial intelligence model", "Virtual assistant")
      .replace("Artificial intelligence model", "Virtual assistant")
      .replace("artificial intelligence model", "Virtual assistant")
      .replaceAll("in HTML", "")
      .replaceAll("HTML", "")
      .replaceAll("html", "")
      .replaceAll("unordered list", "list")
      .replaceAll("Unordered list", "list")
      .replaceAll("ordered list", "list")
      .replaceAll("Ordered list", "list");
  };

  export2Word = (id) => {
    let filename = null;
    var preHtml = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'>
      <head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>`;
    var postHtml = "</body></html>";

    let text = this.sanitizeDescription(
      document.querySelector(id || "#jspdf_export_conversation").innerHTML +
        postHtml
    );
    var html = preHtml + text;

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    filename = filename
      ? filename + ".doc"
      : `${moment(new Date()).format(
          "dddd, MMMM Do YYYY, h:mm:ss a"
        )} - dani.doc`;

    let downloadLink = document.createElement("a");

    downloadLink.classList.add("Select-clear-zone");

    let date = new Date();
    let alphanumericString = date.toISOString().replace(/[-T:.Z]/g, "");

    let class_name = `remove-word-${alphanumericString}`;

    downloadLink.classList.add(class_name);

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    let removeDoc = document.querySelector(`.${class_name}`);
    document.body.removeChild(removeDoc);
  };

  clearChat = () => {
    // this.setState({renderedSteps:[]})
    let start_array = [
      { ...welcomeStep[0], timeStamp: new Date() },
      {...welcomeStep[1],  timeStamp: new Date()}
      // { id: "15", showInput: true, trigger: "4" },
      // { id: "15", showInput: true, trigger: "4" },
    ];

    this.props.clearSteps(start_array);
 
  };

  getLastSearchedResultStepId = (steps) => {
    let lastElemId = null;
    for (let index = 0; index < steps.length; index++) {
      const element = steps[index];

      if (element.searchResults) {
        lastElemId = element.id;
      }
    }

    return lastElemId;
  };

  storeAndStartNewChat = () => {
    this.props.addDaniHistoryChats();
    setTimeout(() => {
      let start_array = [
        { ...welcomeStep[0], timeStamp: new Date() },
        // { id: "15", showInput: true, trigger: "" },
        {...welcomeStep[1],  timeStamp: new Date()}
      ];

      this.props.clearSteps(start_array);
      this.setState({
        showChatSettings: false,
        isChatPage: false,
        currentChatOrder: null,
      });
    }, 500);
  };

  createMarkup = (input) => {
    let m_down = marked.parse(input, {
      breaks: true,
    });
    return m_down;
  };

  replaceName = (message) => {
    if (!message) {
      return;
    }
    const usr = this.props.user.profile;
    if (message.indexOf("_$USER_NAME$_") >= 0) {
      message= message.replace("_$USER_NAME$_", usr.firstName);
    }
    if (message.indexOf("_$DANI_NAME$_") >= 0) {
      message= message.replace("_$DANI_NAME$_", 'Sarvi');
    }
    return message;
  };

  getChatText = (chat) => {
    let firstUserMessage = null;

    const showChatSidebar =
      !isMobile && !this.state.isChatPage && !this.state.showChatSettings;

    for (const message of chat.messages) {
      if (
        message.id != 1 &&
        !message.options &&
        !message.showInput &&
        (message.description || message.message)
      ) {
        firstUserMessage = { ...message };
      }
    }

    if (!firstUserMessage) {
      if (chat.messages.length >= 1) {
        return this.replaceName(chat.messages[0].message);
      } else {
        return "...";
      }
    }

    let textToTurndown =
      firstUserMessage.description || firstUserMessage.message;

    let markdown = new TurndownService().use(gfm).turndown(textToTurndown);
    const incrementor = markdown.length > 140 ? "..." : "";
    markdown = this.sanitizeDescription(markdown);
    const int = showChatSidebar ? 50 : 200;
    return markdown.substring(0, int) + incrementor;
    // return markdown
  };

  handleOpenChat = (chat, key) => {
    this.props.setDaniCurrentChatId(key);
    this.props.clearSteps(chat.messages);
    this.setState({
      showChatSettings: false,
      isChatPage: false,
      currentChatOrder: key,
      actionTaken: false,
    });
    this.props.setDaniLatestStepId(
      this.getLastSearchedResultStepId(chat.messages)
    );
  };

  getChatTime = (time, key) => {
    const today = moment();
    const chatTime = moment(time);
    const diff = today.diff(chatTime, "days");
    console.log(diff);
    if (diff < 1) {
      return moment(chatTime).format("hh:mm A");
    } else if (diff >= 1 && diff < 7) {
      return moment(chatTime).format("dddd");
    } else {
      if (diff > 365) {
        const num = Math.floor(diff / 365);
        return num === 1 ? `${num} Year` : `${num} Years`;
      } else if (diff > 30) {
        const num = Math.floor(diff / 30);
        return num === 1 ? `${num} Month` : `${num} Months`;
      } else {
        const num = Math.floor(diff / 7);
        return num === 1 ? `${num} week` : `${num} Weeks`;
      }
    }
  };

  handleDeleteChatFromList = (chat, key, historyChats) => {
    if (key == this.props.dani.currentChatId) {
      //Here need to other set chat as currentchat id to avoid error
      const otherId = Object.keys(historyChats).find((x) => x != key);
      if (otherId) {
        this.props.setDaniCurrentChatId(otherId);

        this.props.clearSteps(historyChats[otherId].messages);

        this.setState({
          actionTaken: false,
        });
        this.props.setDaniLatestStepId(
          this.getLastSearchedResultStepId(historyChats[otherId].messages)
        );

        setTimeout(() => {
          this.props.deleteDaniHistoryChat(key);
        }, 500);
      } else {
        this.props.deleteDaniHistoryChat(key);
        this.props.addDaniHistoryChats();
        setTimeout(() => {
          let start_array = [
            { ...welcomeStep[0], timeStamp: new Date() },
            {...welcomeStep[1],  timeStamp: new Date()}
            // {
            //   id: "15",
            //   showInput: true,
            //   trigger: "",
            // },
          ];

          this.props.clearSteps(start_array);
          this.setState({
            showChatSettings: false,
            isChatPage: false,
            currentChatOrder: null,
          });
        }, 500);
      }
    } else {
      this.props.deleteDaniHistoryChat(key);
    }
  };

  renderAsHtml = (text) => {
    return parse(this.createMarkup(this.sanitizeDescription(text)));
  };

  renderSortedHistoryChats = (sortedHistoryChats, showChatSidebar) => {
    let{currentChatId}=this.props.dani
    let{outsideUS}=this.state
    return (
      <div
        className={`chat-settings-main-container-chatlist pt-0 ${
          showChatSidebar ? "chat-sidebar-present" : ""
        }`}
      >
        {sortedHistoryChats && Object.keys(sortedHistoryChats).length > 0 ? (
          <div>
            {Object.keys(sortedHistoryChats).map((key) => {
              const chat = sortedHistoryChats[key];
              return (
                <div className={showChatSidebar?"px-2 py-2 desktop-chatlist-main":""} 
                style={{ backgroundColor:  currentChatId==key? '#f0f2f5':'' }} 
                 onClick={() => this.handleOpenChat(chat, key)}>
                <div
                  className={showChatSidebar?"chatlist-message-content-wp":"chatlist-message-content"}
                 
                >
                  <span className="chat-message-heading">{outsideUS? get_translation('fa').navbar_app_name : "Homa"} </span>
                  <span className="chatlist-chattime-container">
                    <span className="chatlist-chattime-text">
                      <span>
                        {" "}
                        {this.getChatTime(chat.time, key)}{" "}
                        <BiChevronRight size={"20px"} />
                      </span>
                    </span>
                    {!showChatSidebar && <br/>}
                    <BiTrash
                      className="mx-2 high-z-indx chatlist-trash-icon"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleDeleteChatFromList(
                          chat,
                          key,
                          sortedHistoryChats
                        );
                      }}
                    />
                    

{/* <BiChevronRight size={"20px"} /> */}
                  </span>   
                  {!showChatSidebar && <div className="chat-message-text">
                {this.getChatText(chat)}
              </div>}               
                </div>
                {showChatSidebar && <div className="chat-message-text" style={{width:"100%"}}>
                {this.getChatText(chat)}
              </div>}
                </div>
              );
            })}
          </div>
        ) : (
          "No chats found"
        )}
      </div>
    );
  };



  renderChatPageTitle=()=>{
    let{outsideUS, isChatPage}=this.state

    let msgTitle = outsideUS? get_translation('fa').navbar_msg_list : 'Messages'
    let setTitle = outsideUS? get_translation('fa').settings_title : 'Settings'


    if(isChatPage){
      return msgTitle
    } else {
      return setTitle
    }

    // chat-settings-title-chat
  }

  render() {
    console.log('render Dani -----')
    let {
      opened,
      renderedSteps,
      currentStep,
      showHelpText,
      minimized,
      historyChats,
      latestStepId,
    } = this.props.dani;

    let {outsideUS}=this.state

    let sortedHistoryChats = { ...historyChats };

    if (historyChats && Object.keys(historyChats).length > 0) {
      let object = { ...historyChats };
      let arrayConvert = [];
      for (const [key, value] of Object.entries(object)) {
        arrayConvert.push({ ...value, key });
      }
      const arrSorted = reverse(
        sortBy(arrayConvert, [
          function(chat) {
            return new Date(chat.time).getTime();
          },
        ])
      );

      const historyChatsSorted = {};

      for (const i of arrSorted) {
        historyChatsSorted[i.key] = { ...i, key: undefined };
      }
      sortedHistoryChats = { ...historyChatsSorted };
    }

    console.log("render again");

    let { renderInPage } = this.props;
    renderInPage=true;
    const showChatSidebar =
      !isMobile && !this.state.isChatPage && !this.state.showChatSettings;
    return (
      <div>
        <div style={{ display: "none" }}>
          <div
            id="jspdf_export_conversation"
            style={{ display: "block" }}
            // style={{display: "none" }}
            className="dani-pdf-convo"
          >
            <h4 className="text-center dani-pdf-convo-text">
              Dani conversations
            </h4>
            {renderedSteps.map((step) => {
              if (step.user) {
                return (
                  <h5 className="dani-export-jspdf-heading dani-pdf-convo-text">
                    <b>My Response</b>:
                    <span className="dani-export-jspdf-danique">
                      {" "}
                      {step.message}{" "}
                    </span>
                  </h5>
                );
              } else if (step.answer || step.searchResults) {
                return (
                  <div className="dani-pdf-convo-text">
                    <b className="dani-export-jspdf-heading">Dani Response</b>:{" "}
                    <div className="dani-export-jspdf-danires">
                      {this.renderAsHtml(step.description || step.message)}
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>

        {!renderInPage && (
          <DaniFloatButton
            opened={opened}
            openDani={this.props.openDani}
            onCloseDani={this.props.closeDani}
            minimized={minimized}
            showHelpText={showHelpText}
            onFloatButtonClick={this.handleFloatButtonClick}
            onCloseHelpText={this.props.closeDaniHelpText}
            currentRoute={this.props.location.pathname}
            currentStep={currentStep}
          />
        )}

        <DaniContainer
          opened={renderInPage ? true : opened}
          minimized={renderInPage ? false : minimized}
          renderInPage={renderInPage}
        >
          <DaniHeader isChatPage={this.state.isChatPage}>
            {isMobile && (
              <span className="free-dani-navbar-msg-container">
              <IoIosArrowBack
                className="dani-chat-header-show-messages"
                size={"20px"}
                onClick={this.openChatsPage}
                data-tip={"Messages"}
                data-for={"dani-chat-header-show-messages"}
              /> 
              <span className="free-dani-navbar-msg-txt">{outsideUS? get_translation('fa').navbar_msg_list : 'Messages'}</span>
                </span>
            )}

            <img className="free-dani dani-chat-profile-icon-header" src={DaniIcon} />
            <div className="dani-header-title">{outsideUS? get_translation('fa').navbar_app_name : 'Homa'}</div>
          

           

            <div
              className="dani-chat-icon-new-message-container"
              data-for={"dani-options-start-new-chat"}
              data-tip={"New chat"}
              onClick={this.storeAndStartNewChat}
            >
              <BsChatDots className="dani-chat-icon-new-message" /> {outsideUS? get_translation('fa').navbar_new_msg : 'New'}
            </div>
          </DaniHeader>

          <div className={showChatSidebar ? "d-flex" : ""}>
            {showChatSidebar &&
              this.renderSortedHistoryChats(
                sortedHistoryChats,
                showChatSidebar
              )}

            <div
              className={`dani-chat-content-box free-dani ${
                showChatSidebar ? "chat-sidebar-present" : ""
              }`}
            >
              <div className="dani-content" ref={(ref) => (this.content = ref)}>
                {map(renderedSteps, this.renderSteps)}

                {this.state.showChatSettings ? (
                  <div
                    className="showChatSettings-view"
                    style={{
                      height: "calc(100%)",
                    }}
                  >
                    <div className={"chat-settings-title"}>
                      <div>
                        <img
                          className="dani-chat-profile-icon-header"
                          src={DaniIcon}
                        />
                        {"Settings"}
                      </div>
                    </div>

                    <div className="chat-settings-main-container">
                      {/* <div
                        className="dani-settings-options"
                        // onClick={this.clearChat}
                      >
                       Types of questions you can ask
                        <BsQuestionCircle
                          size={"20px"}
                          className="dani-settings-option-icon mr-2"
                        />
                        <BenchMarkDetailsModal
                          text={"Types of questions you could ask"}
                        />
                      </div> */}

                      <div
                      className="dani-settings-options"
                      onClick={() => {
                        // this.setState({ exporting: true }, () => {
                        this.exportConvoPDF();
                        // });
                      }}
                    >
                        <BsDownload
                        size={"20px"}
                        className="dani-settings-option-icon mr-2"
                      />
                      {outsideUS? get_translation('fa').settings_chat_pdf : 'Download entire chat as PDF'} 
                    </div>

                      {!outsideUS? <div
                      className="dani-settings-options"
                      onClick={() => this.export2Word()}
                    >
                       <BsDownload
                        size={"20px"}
                        className="dani-settings-option-icon mr-2"
                      />
                    Download entire chat as Word document                      
                      {this.state.isWordLink ? (
                        <div>
                          <a
                            href={this.state.isWordLink}
                            target="_blank"
                            download
                          >
                            Click here
                          </a>
                        </div>
                      ) : null}
                    </div>:null}

                      {!renderInPage && (
                        <div
                          className="dani-settings-options"
                          onClick={() => {
                            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
                            width=600,height=500,left=100,top=100`;
                            window.open(`/home/expand/dani`, "test", params);
                          }}
                        >
                          <BiLinkExternal
                            size={"20px"}
                            className="dani-settings-option-icon mr-2"
                          />{" "}
                          Open in new window
                        </div>
                      )}

                      <div
                        className="dani-settings-options"
                        onClick={this.storeAndStartNewChat}
                      >
                        {" "}
                        <BsChatDots
                          size={"20px"}
                          className="dani-settings-option-icon mr-2"
                        />
                        {outsideUS? get_translation('fa').navbar_new_msg : 'New message'}  
                      </div>


                      <div
                        className="dani-settings-options"
                        onClick={() => {
                          this.setState((prevState) => ({
                            showChatSettings: !prevState.showChatSettings,
                            settingTitle: "",
                          }));
                        }}
                      >
                        <BsXCircle
                          size={"20px"}
                          className="dani-settings-option-icon mr-2"
                        />
                        {outsideUS? get_translation('fa').settings_close : 'Close settings'} 
                      </div>
                    </div>
                  </div>
                ) : null}

                {this.state.isChatPage ? (
                  <div
                    className="showChatSettings-view"
                    style={{
                      height: "100%",
                    }}
                  >
                    <div className={"chat-settings-title-chat"}>
                      <BsGear
                        size={"20px"}
                        data-tip={"Settings"}
                        data-for={"dani-options-settings-hover"}
                        className="ml-2"
                        onClick={() => {
                          this.setState((prevState) => ({
                            showChatSettings: true,
                            isChatPage: false,
                            settingTitle: "",
                          }));
                        }}
                      />
                      <div>
                        <img
                          className="dani-chat-profile-icon-header"
                          src={DaniIcon}
                        />
                        {
                        this.renderChatPageTitle()
                        }
                      </div>

                      <span style={{ fontWeight: "300", fontSize: "13px" }}>
                        <BsChatDots
                          size={"20px"}
                          onClick={this.storeAndStartNewChat}
                          className="cursor-pointer"
                        />{" "}
                        {outsideUS? get_translation('fa').navbar_new_msg : 'New'}
                      </span>
                    </div>
                    {this.state.isChatPage
                      ? this.renderSortedHistoryChats(sortedHistoryChats, false)
                      : null}
                  </div>
                ) : null}
                {this.props.dani.loadingSearchResult && (
                  <div className="dani-loader-main-wrapper">
                    <img
                      className="dani-chat-profile-icon"
                      // style={{
                      //   marginBottom: "10px",
                      //   width: "30px",
                      //   marginLeft: "15px",
                      // }}
                      src={DaniIcon}
                    />
                    <div
                      className="mt-3 ml-1 p-2 dani-step"
                      style={{ width: "50px", height:'40px', minWidth:'9%' }}
                    >
                      <div className="ml-3 dani-load-res"></div>
                    </div>
                  </div>
                )}
                {/*{currentStep &&
                renderedSteps.length > 1 &&
                !["1", "4"].includes(
                  renderedSteps[renderedSteps.length - 2].id
                ) &&
                !this.props.dani.loadingSearchResult && (
                  <GoBackComponent onGoBack={() => this.triggerFirstStep()} />
                )}*/}
              </div>
           
           
           
              {(currentStep && currentStep.showInput) || isIphone ? (
                <div
                  id="dani-input-message-div"
                  style={{ display: this.state.isChatPage ? "none" : "block" }}
                >
                  {/* <div style={{position:'relative'}}> */}
                  {/* <span className="dani-question-input-length">
                  {this.state.inputLength}/600 characters
                </span>
                <span 
                 name="̵comment"
                 id="dani-question-input"
                 style={{
                  color: "#54555A",
                }}
                placeholder="Type a message..."
                ref={(c) => (this.questionInput = c)}
                onKeyUp={this.handleKeyPress}
                class="textarea" role="textbox" 
                contentEditable maxLength="600"/> */}

                  <textarea
                    name="̵comment"
                    id="dani-question-input"
                    rows={1}
                    style={{
                      color: "#54555A",
                    }}
                    placeholder="Type a message..."
                    ref={(c) => (this.questionInput = c)}
                    onKeyUp={(e)=>this.handleKeyPress(e,currentStep.isPdfExtract)}
                  />
                  <Button
                    data-tip={"Send chat"}
                    data-for={"dani-options-send-hover"}
                    className="dani-send-question-button mr-2"
                    onClick={()=>this.handleQuestionSubmit(currentStep.isPdfExtract)}
                  >
                    <i className="send-icon flaticon-send"></i>
                  </Button>

                  {/* <Button
                    className="dani-send-question-button"
                    style={{ left: "8px" }}
                  >
                    <label htmlFor="dani-pdf-input">
                      <BsUpload />
                    </label>
                    <input
                      id="dani-pdf-input"
                      onChange={this.onFileChange}
                      type="file"
                    />
                  </Button> */}

                  <BsGear
                    size={"20px"}
                    data-tip={"Settings"}
                    data-for={"dani-options-settings-hover"}
                    className="dani-settings-button"
                    onClick={() => {
                      this.setState((prevState) => ({
                        showChatSettings: !prevState.showChatSettings,
                        settingTitle: "",
                      }));
                    }}
                  />
                  <ReactTooltip
                    id="dani-options-settings-hover"
                    place={"left"}
                  />
                  <ReactTooltip id="dani-options-send-hover" place={"left"} />

                  <ReactTooltip
                    id="dani-chat-header-show-messages"
                    place={"right"}
                  />
                  <ReactTooltip
                    id="dani-options-open-in-new-tab"
                    place={"left"}
                  />
                  <ReactTooltip
                    id="dani-options-start-new-chat"
                    place={"left"}
                  />
                  {/* </div> */}
                </div>
              ) : null}
            </div>
          </div>
        </DaniContainer>
        {/* {isMobile ? <FooterBar /> : null} */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dani: state.dani,
    user: {
        _id: Math.random().toString(36).slice(2),
        profile: {
          firstName:'Guest',
          lastName:'User',
          profilePic:'https://images.unsplash.com/photo-1685195154261-c8167ca7f88c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1364&q=80'
        },
        organizationId:{_id: Math.random().toString(36).slice(2)}
    },
    kpiMaster: state.kpiMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openDani: () => dispatch(actionCreators.openDani()),
    closeDani: () => dispatch(actionCreators.closeDani()),
    optionSelected: (step) => dispatch(actionCreators.optionSelected(step)),
    triggerNextStep: (step) => dispatch(actionCreators.triggerNextStep(step)),
    triggerStep: (step) => dispatch(actionCreators.triggerStep(step)),
    fetchRecommendedTools: (kpiName) =>
      dispatch(actionCreators.fetchRecommendedTools(kpiName)),
    fetchMoreSearchResults: (results, page) =>
      dispatch(actionCreators.fetchMoreSearchResults(results, page)),
    fetchSearchResults: (
      keyword,
      type,
      messages,
      systemType,
      showMore,
      downloadable,
      step,
      currentChatId,
      isOpenAPI,
      default_language
    ) =>
      dispatch(
        actionCreators.fetchSearchResults(
          keyword,
          type,
          messages,
          systemType,
          showMore,
          downloadable,
          step,
          currentChatId,
          isOpenAPI, 
          default_language
        )
      ),
    closeDaniHelpText: () => dispatch(actionCreators.closeDaniHelpText()),
    selectKpiForChart: (chart) =>
      dispatch(actionCreators.selectKpiForChart(chart)),
    minimizeDani: () => dispatch(actionCreators.minimizeDani()),
    maximizeDani: () => dispatch(actionCreators.maximizeDani()),
    toolkitSelected: (s) => dispatch(actionCreators.toolkitSelected(s)),
    drillDownChart: () => dispatch(actionCreators.drillDownChart()),
    clearSteps: (step) => dispatch(actionCreators.clearSteps(step)),
    updateStep: (step) => dispatch(actionCreators.updateStep(step)),
    setDaniResponseLoading: (data) =>
      dispatch(actionCreators.setDaniResponseLoading(data)),
    addDaniHistoryChats: (data) =>
      dispatch(actionCreators.addDaniHistoryChats(data)),
    setDaniLatestStepId: (data) => {
      dispatch(actionCreators.setDaniLatestStepId(data));
    },
    setDaniCurrentChatId: (data) => {
      dispatch(actionCreators.setDaniCurrentChatId(data));
    },
    setDaniExtractedText: (data) => {
      dispatch(actionCreators.setDaniExtractedText(data));
    },
    deleteDaniHistoryChat: (data) => {
      dispatch(actionCreators.deleteDaniHistoryChat(data));
    },
    resetDaniFileMultiPartData: () => {
      dispatch(actionCreators.resetDaniFileMultiPartData());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeDani);
